export default {
	version: 'Version',
	accessibilityBtn: 'Accessibilité : partiellement conforme',
	accessibilityTitle: 'Accessibilité',
	termConditionBtn: 'CGU et Mentions légales',
	termConditionTitle: 'CGU et Mentions légales',
	cguDialogTitle: 'CGU et Mentions légales',
	date: 'Octobre 2026',
	contactBtn: 'Contact Support',
	supportServiceBtn: 'Centre d\'aide'
};
